// sendButtonMode.js — S-H1 Send/Stop button morph (adversarial P0-4).
//
// No backend cancel route exists, and with F5 raising maxTurns to 24 on Opus a runaway reply
// must be rideable. V1 = the Send button becomes a Stop (square) while the agent is `working`;
// Stop is a client-side abort (stop rendering the live lane, mark the turn "stopped", re-enable
// the composer — the server run still finishes, but the user regains control). This pure helper
// just picks the button mode from the run state; the JSX renders the right glyph/handler.
//
// Pure + import-free → node-testable under `node --test`.

export function sendButtonMode({ working } = {}) {
  return working ? "stop" : "send"
}
